import ProductHero from './ProductHero.jsx';
import BuiltToGrow from './BuiltToGrow.jsx';
import KeyBenefits from './KeyBenefits.jsx';
import IdealFor from './IdealFor.jsx';

/** SOFAR product page. */
export default function Sofar() {
  return (
    <>
      <ProductHero />
      <BuiltToGrow />
      <KeyBenefits />
      <hr />
      <IdealFor />
    </>
  );
}
